<template>
    <div>
        <div class="query-c">
            查询：
            <Input search placeholder="请输入查询内容" style="width: auto" />
        </div>
        <br>
        <Table border stripe :columns="columns1" :data="data1"></Table>
        <br>
        <Page :total="100" show-sizer show-elevator/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            columns1: [
                {
                    title: 'Name',
                    key: 'name'
                },
                {
                    title: 'Age',
                    key: 'age'
                },
                {
                    title: 'Address',
                    key: 'address'
                },
                {
                    title: 'Address1',
                    key: 'address1'
                },
                {
                    title: 'Address2',
                    key: 'address2'
                },
                {
                    title: 'Address3',
                    key: 'address3'
                }
            ],
            data1: [
                {
                    name: 'John Brown',
                    age: 18,
                    address: 'New York No. 1 Lake Park',
                    address1: 'New York No. 1 Lake Park',
                    address2: 'New York No. 1 Lake Park',
                    address3: 'New York No. 1 Lake Park',
                    date: '2016-10-03'
                },
                {
                    name: 'Jim Green',
                    age: 24,
                    address: 'London No. 1 Lake Park',
                    address1: 'New York No. 1 Lake Park',
                    address2: 'New York No. 1 Lake Park',
                    address3: 'New York No. 1 Lake Park',
                    date: '2016-10-01'
                },
                {
                    name: 'Joe Black',
                    age: 30,
                    address: 'Sydney No. 1 Lake Park',
                    address1: 'New York No. 1 Lake Park',
                    address2: 'New York No. 1 Lake Park',
                    address3: 'New York No. 1 Lake Park',
                    date: '2016-10-02'
                },
                {
                    name: 'Jon Snow',
                    age: 26,
                    address: 'Ottawa No. 2 Lake Park',
                    address1: 'New York No. 1 Lake Park',
                    address2: 'New York No. 1 Lake Park',
                    address3: 'New York No. 1 Lake Park',
                    date: '2016-10-04'
                }
            ]
        }
    }
}
</script>

<style scoped>

</style>